import React, { useContext, useEffect } from "react";
import NavButton from "../../components/NavButton/index";
import MsmContext, { Actions } from "../../reducers/Context";
import { useDataApi, API } from "../../components/API/index";
import { getSmartlookData, setStorageData, removeDuplicatesByProp } from "../../utils";
import LoaderAnim from "../../components/LoaderAnim";

const ConfirmDetails = () => {
  const { dispatch, state } = useContext(MsmContext);

  console.log("state", state);

  const { data, doFetch, isLoading } = useDataApi("");

  const completeSignup = () => {
    doFetch(
      state.teamMemberMode ? API.COMPLETE_TM_SIGNUP : API.COMPLETE_SIGNUP,
      {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: `jsonData=${encodeURIComponent(
          JSON.stringify({
            user: state.user,
            location: state.location,
            team: state.team,
            sid: state.sid,
            ...getSmartlookData(),
          })
        )}`,
      },
      { ignoreCache: true }
    );
    dispatch({
      type: Actions.COMPLETED_SIGNUP,
    });
  };

  useEffect(() => {
    if (data) {
      const userTeam = data.signup.teams.reduce(
        function (acc, team) {
          return team.TeamID > acc.TeamID ? team : acc;
        },
        { TeamID: 0 }
      );
      const deDuped = removeDuplicatesByProp(data.signup.teams, "TeamID");
      const onlyActive = deDuped.filter((team) => team.TeamSiteActiveID !== 0);

      console.log("userTeam", userTeam);

      setStorageData("user", userTeam);
      setStorageData("userTeams", deDuped);
      setStorageData("loginTeams", onlyActive);
      setStorageData("sid", data.signup.session.SessionID);

      //console.log("got signup data", data);
      window.tsUtilityModals.signupCompleteCallback(userTeam);
    }
  }, [data]);

  return (
    <>
      {isLoading ? (
        <LoaderAnim />
      ) : (
        <div className="afs-msm-stage-content add-all-padding">
          <p>Please check the following details are correct:</p>
          {(state.user.name || state.user.firstName) && (
            <div>
              <p>Your name:</p>
              <p>
                <b>{state.user.name || `${state.user.firstName} ${state.user.surname}`}</b>
              </p>
            </div>
          )}
          {(state.user.email || state.user.networkEmail) && (
            <div>
              <p>Your email:</p>
              <p>
                <b>{state.user.email || state.user.networkEmail}</b>
              </p>
            </div>
          )}

          {state.team && (
            <div>
              <p>Your team name:</p>
              <p>
                <b>{state.team.TeamName || state.team.TeamSiteDisplayName || state.team.FullTimeTeamName}</b>
              </p>
            </div>
          )}
          {state.location && (
            <div>
              <p>Your location: </p>
              <p>
                <b>{(state.location.TeamTown + ", " + state.location.TeamCounty + ", " + state.location.TeamCountry).replace(", , ", ", ")}</b>
              </p>
            </div>
          )}
        </div>
      )}
      <div className="afs-msm-stage-action-buttons">
        <NavButton text="BACK" actionType={Actions.PREV_STAGE} />
        <NavButton text={state.teamMemberMode ? "CONFIRM DETAILS" : "COMPLETE SIGNUP"} type="submit" onClick={completeSignup} />
      </div>
    </>
  );
};

export default {
  id: "confirm-details",
  title: "Sign up to TeamStats",
  subtitles: [""],
  imageUrl: "https://assets.teamstats.net/img-m-600-70/backgrounds/football-background-3.jpg",
  component: ConfirmDetails,
};
